import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../utils/api_instance.util";
import { errorToastify } from "../utils/toastify.util";

const initialState = {
	countryList: [],
	stateList: [],
};

export const getCountryList = createAsyncThunk(
	"countryState/countryList",
	async () => {
		try {
			let payload={
				searchText : ""
			}
			const { data } = await instance.post(
				"/api/v1/country-state/country-list", payload
			);
			return data;
		} catch (err) {
			const { data } = err.response;
			return data;
		}
	}
);

export const getStateByCountry = createAsyncThunk(
	"countryState/getStateByCountry",
	async (payload, { dispatch }) => {
		try {
			const { data } = await instance.post(
				"/api/v1/country-state/state-list-by-country",
				payload
			);

			return data;
		} catch (err) {
			const { data } = err.response;
			errorToastify(data.message);
			return data;
		}
	}
);

const countryStateSlice = createSlice({
	name: "modal",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getCountryList.fulfilled, (state, action) => {
			if (action.payload?.success || false) {
				state.countryList = action.payload.result;
			} else {
				state.countryList = [];
			}
		});
		builder.addCase(getStateByCountry.fulfilled, (state, action) => {
			if (action.payload?.success || false) {
				state.stateList = action.payload.result;
			} else {
				state.stateList = [];
			}
		});
	},
});

export default countryStateSlice.reducer;
export const countryStateActions = countryStateSlice.actions;
